import { Divider } from '@advanza/ui'
import clsx from 'clsx'
import { KEYWORD_MAPPING_FOCUS_RING } from 'components/keywordMappings/keywordMappingModel'
import KeywordMappingSearchIntents from 'components/keywordMappings/KeywordMappingSearchIntents'
import KeywordMappingsList from 'components/keywordMappings/KeywordMappingsList'
import Restricted from 'components/Restricted'
import Page from 'components/ui/Page'
import { useSearchParams } from 'react-router-dom'

type KeywordMappingTab = 'keywords' | 'search-intents'

const TABS: { id: KeywordMappingTab; label: string }[] = [
    { id: 'keywords', label: 'Keywords' },
    { id: 'search-intents', label: 'Search intents' },
]

const KeywordMappingsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const activeTab: KeywordMappingTab =
        searchParams.get('tab') === 'search-intents' ? 'search-intents' : 'keywords'

    const setTab = (tab: KeywordMappingTab) => {
        setSearchParams(
            (prev) => {
                if (tab === 'keywords') {
                    prev.delete('tab')
                    return prev
                }
                prev.set('tab', 'search-intents')
                return prev
            },
            { replace: true },
        )
    }

    return (
        <Page title="Keyword mapping">
            <Divider m />
            <h1>Keyword mapping</h1>
            <div
                role="tablist"
                aria-label="Keyword mapping"
                className="mt-4 flex gap-1 border-b border-solid border-[#e4e7ec]">
                {TABS.map((tab) => (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        id={`keyword-mapping-tab-${tab.id}`}
                        aria-selected={activeTab === tab.id}
                        aria-controls={`keyword-mapping-panel-${tab.id}`}
                        className={clsx(
                            '-mb-px border-b-2 px-4 py-3 text-sm font-semibold',
                            KEYWORD_MAPPING_FOCUS_RING,
                            activeTab === tab.id
                                ? 'border-[#5a8bfc] text-[#1d4ed8]'
                                : 'border-base-transparent text-[#344054]',
                        )}
                        onClick={() => setTab(tab.id)}>
                        {tab.label}
                    </button>
                ))}
            </div>
            <Divider m />
            <Restricted location="keyword_mappings" checkWrite={false} showMessage>
                <div
                    role="tabpanel"
                    id={`keyword-mapping-panel-${activeTab}`}
                    aria-labelledby={`keyword-mapping-tab-${activeTab}`}>
                    {activeTab === 'keywords' ? (
                        <KeywordMappingsList />
                    ) : (
                        <KeywordMappingSearchIntents />
                    )}
                </div>
            </Restricted>
        </Page>
    )
}

export default KeywordMappingsPage
